<template>
  <div>
    <br>
      <h1>ペットのマイページ</h1>
      <br>
      <el-form :model="form" :rules="rules" ref="form">
        <div v-loading="loading">
          <div v-loading="loading">
            <div class="pet-image-row">
              <el-card class="pet-card">
                <img :src="form.maeImgUrl" class="pet-image" />
              </el-card>
              <el-card class="pet-card">
                <img :src="form.zenshinImgUrl" class="pet-image" />
              </el-card>
            </div>
            <table width="100%" border=0 style="font-size:15px;line-height:1.5em;">
              <tr>
                <td>
                  <el-form-item label="ペットネーム" prop="petName">
                    <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 15 }" v-model="form.petName" autocomplete="off" placeholder="64桁以内" maxlength="64" :disabled="!editMode || readOnlyMode"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="性別" prop="seibetsu">
                    <el-radio v-model="form.seibetsu" label="0" :disabled="!editMode || readOnlyMode">オス</el-radio>
                    <el-radio v-model="form.seibetsu" label="1" :disabled="!editMode || readOnlyMode">メス</el-radio>
                    <el-radio v-model="form.seibetsu" label="2" :disabled="!editMode || readOnlyMode">不明</el-radio>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="好きな食べ物" prop="sukinatabemono">
                    <el-input
                      type="textarea"
                      v-model="form.sukinatabemono"
                      :autosize="{ minRows: 1, maxRows: 15 }"
                      autocomplete="off"
                      placeholder="256桁以内"
                      maxlength="256"
                      :disabled="!editMode || readOnlyMode">
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="趣味" prop="shumi">
                    <el-input
                      type="textarea"
                      v-model="form.shumi"
                      :autosize="{ minRows: 1, maxRows: 15 }"
                      autocomplete="off"
                      placeholder="256桁以内"
                      maxlength="256"
                      :disabled="!editMode || readOnlyMode">
                    </el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-button native-type="button" type="primary" @click="updatePetInfo()" plain :disabled="readOnlyMode">　保　存　</el-button>
                  <el-button native-type="button" type="primary" @click="editMode = true" plain :disabled="readOnlyMode">　編　集　</el-button>
                  <el-button v-if="isStopCareButtonVisible()" native-type="button" type="danger" @click="stopPetCare()" plain :disabled="readOnlyMode">　飼育中止　</el-button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </el-form>
      <br>
      <br>
      <h1>ペット体調管理</h1>
      <br>
      <el-form :model="form" >
        <div v-loading="loading">
          <div v-if="!loading">
            <div v-if="kusuriTechoList.length > 0">
              <div class="medsTableWrapper">
                <table class="commonTable medsTable">
                  <tr>
                    <th width="5%">#</th>
                    <th width="15%">病院名</th>
                    <th width="15%">検査日</th>
                    <th>検査内容</th>
                  </tr>
                  <tr v-for="(item, index) in kusuriTechoList" :key="item.kusuriTechoSeq">
                    <td><el-button native-type="button" type="primary" plain @click="goPetHealth(item.kusuriTechoSeq);" :disabled="readOnlyMode">{{ index + 1 }}</el-button></td>
                    <td>{{ item.biyouinName }}</td>
                    <td>{{ item.kensaDate }}</td>
                    <td>{{ item.kensaNaiyo }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div v-else>データがありません</div>
          </div>
          <br>
          <table width="100%" border=0 style="font-size:15px;line-height:1.5em;">
          <tr>
            <td>
              <el-button native-type="button" type="primary" @click="goPetHealth()" plain :disabled="readOnlyMode">　追　加　</el-button>
            </td>
          </tr>
          </table>
        </div>
      </el-form >
      <br>
      <br>
      <el-form :model="form">
        <h1>血統証</h1>
        <br>
        <div v-loading="loading">
          <div v-loading="loading">
            <table class="commonTable">
              <tr>
                <td>
                  <table class="commonSubTable">
                    <tr>
                      <td>
                        <input type="file" ref="kettoshoFile" accept="image/jpeg,image/png,image/webp" :disabled="readOnlyMode">
                      </td>
                    </tr>
                    <tr v-if="form.kettoshoPdfUrl">
                      <td>
                        <img :src="form.kettoshoPdfUrl" style="width: 100%; height: 250px; object-fit: contain;"/>
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <div class="blood-actions">
                    <!-- <el-button v-if="kettoshoPdfUrl" native-type="button" type="primary" plain @click="download();" :disabled="readOnlyMode">ダウンロード</el-button> -->
                    <el-button native-type="button" type="primary" plain @click="uploadKettoshoFile();" :disabled="readOnlyMode">アップロード</el-button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </el-form >
      <br>
      <br>
      <h1>投稿一覧</h1>
      <br>
      <el-form :inline="true" :model="form" @submit.native.prevent>
        <div v-loading="loading">
          <div v-if="!loading">
            <table class="commonTable">
              <tr>
                <td>
                  <table class="commonSubTable">
                    <tr>
                      <th>新規</th>
                    </tr>
                    <tr>
                      <td><el-input v-model="form.imgComment" autocomplete="off" placeholder="256桁以内"  maxlength="256" :disabled="readOnlyMode"></el-input></td>
                    </tr>
                    <tr>
                      <td>
                        <input type="file" ref="imageFile" accept="image/jpeg,image/png,image/webp" :disabled="readOnlyMode">
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <el-button native-type="button" type="primary" plain @click="uploadImageFile();" :disabled="readOnlyMode">アップロード</el-button>
                  <br>
                  <el-form-item prop="kokaiFlg" class="kokai-flg">
                    <el-radio v-model="form.kokaiFlg" label="1" :disabled="readOnlyMode">公開しない</el-radio>
                    <el-radio v-model="form.kokaiFlg" label="2" :disabled="readOnlyMode">マンション内公開</el-radio>
                    <el-radio v-model="form.kokaiFlg" label="3" :disabled="readOnlyMode">一般公開</el-radio>
                  </el-form-item>
                  <br>
                  <el-form-item class="img-upload-comment">
                    <span>※jpg、pngの拡張子で10M以内でアップロードしてください。</span>
                  </el-form-item>
                  <br>
                </td>
              </tr>
              <tr v-if="petPhotoList.length > 0" v-for="item in petPhotoList" :key="item.arubamuSeq">
                <td>
                  <table class="commonSubTable">
                    <tr>
                      <td>{{ item.postDate }}</td>
                    </tr>
                    <tr v-if="item.imgComment">
                      <td>{{ item.imgComment }}</td>
                    </tr>
                    <tr>
                      <td>
                        <img :src="item.imgUrl" style="width: 100%; height: 250px; object-fit: contain;"/>
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <div class="blood-actions">
                    <el-button native-type="button" type="danger" plain @click="deletePetPhoto(item);" :disabled="readOnlyMode">削除</el-button>
                    <el-button native-type="button" type="primary" plain @click="updateKoukaiFlg(item);" :disabled="readOnlyMode">公開権限更新</el-button>
                  </div>
                  <el-form-item prop="kokaiFlg" class="kokai-flg">
                    <el-radio v-model="item.kokaiFlg" label="1" :disabled="readOnlyMode">公開しない</el-radio>
                    <el-radio v-model="item.kokaiFlg" label="2" :disabled="readOnlyMode">マンション内公開</el-radio>
                    <el-radio v-model="item.kokaiFlg" label="3" :disabled="readOnlyMode">一般公開</el-radio>
                  </el-form-item>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <br>
        <div v-if="loading"><br><br><br><br><br><br></div>
      </el-form>
  </div>
</template>

<script>
import request from '@/utils/request';
import { validateFile } from '@/utils/tools';
import { Message, MessageBox } from 'element-ui';
import { getShiikuStatusLabel, getWfStatusLabel } from '@/utils/constant';
import imageCompression from 'browser-image-compression';

export default {
  name: 'MyPetHome',
  data() {
    return {
      loading: false,                   // ローディング中
      editMode: false,                  // デフォルトは読み取り専用
      petSeq: this.$route.query.petSeq, // 前画面で選択したペットのpetSeq
      shiikuStatus: '',                 // 飼育ステータス
      wfStatus: '',                     // 承認ステータス
      form: {
        kettoshoPdfUrl: '',             // 血統証明書URL
        maeImgUrl: '',                  // 前写真URL  
        zenshinImgUrl: '',              // 全身写真URL  
        petName: '',                    // ペットネーム  
        seibetsu: '',                   // 性別
        sukinatabemono: '',             // 好きな食べ物 
        shumi: '',                      // 趣味
        imgComment: '',                 // コメント(新規)
        kokaiFlg: '',                   // 公開フラグ(新規)
      },
      kusuriTechoList: [],              // お薬手帳
      petPhotoList: [],                 // 投稿一覧
      rules: { petName: [{ required: true, message: '必須です。', trigger: 'blur' }] }
    };
  },
  computed: {
    // 読み込み専用モード
    readOnlyMode() {
      return this.getShiikuStatusLabel(this.shiikuStatus) === '飼育中止' 
        || this.getWfStatusLabel(this.wfStatus) === '却下';
    }
  },
  created() {
    // ペット情報取得
    this.getMyPetHomeInfo();
  },
  
  methods: {
    // 飼育ステータス名称取得
    getShiikuStatusLabel,
    // 承認ステータス名称取得
    getWfStatusLabel,
    // 飼育中止ボタン表示判定
    isStopCareButtonVisible() {
      return getShiikuStatusLabel(this.shiikuStatus) === '飼育中' && getWfStatusLabel(this.wfStatus) === '承認済';
    },
    // ペット情報取得
    getMyPetHomeInfo() {
      this.loading = true;
      request('getMyPetHomeInfo', this.petSeq).then((res) => {
        this.shiikuStatus = res.pet.shiikuStatus;
        this.wfStatus = res.pet.wfStatus;
        this.form.kettoshoPdfUrl = res.pet.kettoshoPdfUrl;
        this.form.maeImgUrl = res.pet.maeImgUrl;
        this.form.zenshinImgUrl = res.pet.zenshinImgUrl;
        this.form.petName = res.pet.petName;
        this.form.seibetsu = res.pet.seibetsu;
        this.form.sukinatabemono = res.pet.sukinatabemono;
        this.form.shumi = res.pet.shumi;
        this.kusuriTechoList = res?.kusuriTechoList;
        this.petPhotoList = res?.petPhotoList;
      }).finally(() => {
        this.loading = false;
      });   
    },
    // ペット情報更新
    updatePetInfo() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            petSeq: this.petSeq,
            petName: this.form.petName,
            seibetsu: this.form.seibetsu,
            sukinatabemono:this.form.sukinatabemono,
            shumi: this.form.shumi
          };
          request('savePetInfo', params).then((res) => {
            Message.success(res.msg);
            this.editMode = false;
          });  
        } 
      });
    },
    // 飼育中止
    stopPetCare() {
      MessageBox.confirm('飼育中止してもよろしいですか？<br>※この操作は取り消しできません', '確認', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        request('stopPetCare', this.petSeq).then((res) => {
          Message.success(res.msg);
          this.goMyPets();
        });  
      });
    },
    // // ダウンロード
    // download() {
    //   // iOSのSafariのブロックを防ぐために事前に新規タブを開く
    //   const newWindow = window.open('about:blank');
    //   request('download', this.kettoshoPdfUrl).then((res) => {
    //     newWindow.location = res.generatePresignedUrl;
    //   });
    // },
    // 血統証アップロード
    async uploadKettoshoFile() {
      const kettoshoFile = this.$refs.kettoshoFile.files[0];
      // ファイルチェック
      const msg = validateFile(kettoshoFile, { allowedTypes: ['image/jpeg', 'image/png', 'image/webp'], maxSizeMB: 20 });
      if (msg) {
        this.$message.error(msg);
        return;
      }
      try {
        this.loading = true;
        // 圧縮処理
        const options = {
          maxSizeMB: 1,                // 最大1MB
          maxWidthOrHeight: 1920,      // 最大幅または高さ
          useWebWorker: true,          // Web Workerを使用してパフォーマンス向上
          fileType: kettoshoFile.type, // 元のファイル形式を保持
          initialQuality: 0.8          // 初期品質（必要に応じて調整）
        };
        const compressedFile = await imageCompression(kettoshoFile, options);
        // アップロード処理
        const formData = new FormData();
        formData.append('file', compressedFile);
        formData.append('petSeq', this.petSeq);
        const res = await request('uploadKettoshoFile', formData);
        // ペット情報再取得
        this.getMyPetHomeInfo();
        Message.success(res.msg);
        // 血統証選択をクリア
        this.$refs.kettoshoFile.value = ''; 
      } finally {
        this.loading = false;
      }
    },
    // 画像アップロード
    async uploadImageFile() {
      const imageFile = this.$refs.imageFile.files[0];
      // ファイルチェック
      const msg = validateFile(imageFile, { allowedTypes: ['image/jpeg', 'image/png', 'image/webp'], maxSizeMB:20 });
      if (msg) {
        this.$message.error(msg);
        return;
      }
      // 公開フラグチェック
      if (!this.form.kokaiFlg) {
        this.$message.error('公開フラグを選択してください。');
        return;
      }
      try {
        this.loading = true;
        // 圧縮処理
        const options = {
          maxSizeMB: 1,             // 最大1MB
          maxWidthOrHeight: 1920,   // 最大幅または高さ
          useWebWorker: true,       // Web Workerを使用してパフォーマンス向上
          fileType: imageFile.type, // 元のファイル形式を保持
          initialQuality: 0.8       // 初期品質（必要に応じて調整）
        };
        const compressedFile = await imageCompression(imageFile, options);
        // アップロード処理
        const formData = new FormData();
        formData.append('file', compressedFile);
        formData.append('petSeq', this.petSeq);
        formData.append('kokaiFlg', this.form.kokaiFlg);
        formData.append('imgComment', this.form.imgComment);
        const res = await request('uploadImageFile', formData);
        // ペット情報再取得
        this.getMyPetHomeInfo();
        Message.success(res.msg);
        // 画像選択をクリア
        this.form.imgComment = '';
        this.form.kokaiFlg = '';
        this.$refs.imageFile.value = ''; 
      } finally {
        this.loading = false;
      }
    },
    // 公開権限更新
    updateKoukaiFlg(item) {
      const params = {
        arubamuSeq: item.arubamuSeq,
        kokaiFlg: item.kokaiFlg
      };
      request('updateKoukaiFlg', params).then((res) => {
        Message.success(res.msg);
      });  
    },
    // ペット写真削除
    deletePetPhoto(item) {
      const imgComment = item.imgComment ? `写真「${item.imgComment}」` : 'この写真';
      MessageBox.confirm(`${imgComment} を削除してもよろしいでしょうか？`, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        request('deletePetPhoto', item.arubamuSeq).then((res) => {
          // this.petPhotoList = this.petPhotoList.filter(a => a.arubamuSeq !== item.arubamuSeq);
          // ペット情報再取得
          this.getMyPetHomeInfo();
          Message.success(res.msg);
        });  
      });
    },
    goMyPets() {
      this.$router.push({
        path: '/myPets',
      }).catch(() => {});
    },
    goPetInfo() {
      this.$router.push({
        path: '/petInfo',
      }).catch(() => {});
    },
    goOwnerBord() {
      this.$router.push({
        path: '/ownerBord',
      }).catch(() => {});
    },
    goPetHealth(kusuriTechoSeq) {
      this.$router.push({
        path: '/petHealth',
        query: {
          petSeq: this.petSeq,
          ...(kusuriTechoSeq && { kusuriTechoSeq })
        }
      }).catch(() => {});
    },
    filterSpecialChars(value) {
      this.form.petName = value.replace(/[^\u4e00-\u9fa5\u3040-\u309f\u30a0-\u30ff\u31f0-\u31ffa-zA-Z0-9]/g, '');
    },
  },
};
</script>

<style lang="less">
  h1 {
    padding-top: 10em;
    padding: 0.25em 0.5em;            /*上下 左右の余白*/
    color: #494949;                 /*文字色*/
    background: transparent;          /*背景透明に*/
    border-left: solid 5px #7db4e6; /*左線*/
  }
  html, body {
    overflow-x: hidden;
  }
  .commonTable {
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border: 2px solid #778ca3;
    box-sizing: border-box;
  }
  .commonTable th,
  .commonTable td {
    padding: 5px;
    border: 1px solid #778ca3;
    text-align: left;
    word-break: break-word;
  }
  .commonTable th {
    background: #e9faf9;
    border-bottom: 2px solid #778ca3;
    text-align: center;
  }
  .commonSubTable {
    width: 100%;
    table-layout: auto;
    border: 1px solid #778ca3;
    border-collapse: collapse;
    box-sizing: border-box;
    margin: 0;                      
  }
  .commonSubTable th,
  .commonSubTable td {
    border: 1px solid #778ca3 !important;
    padding: 10px !important; 
    text-align: left; 
  }
  .commonSubTable {
    table-layout: fixed;
  }
  .medsTableWrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .medsTable {
    display: inline-table;
    width: auto !important;
    table-layout: fixed !important;
    min-width: 600px;
  }
  .medsTable th,
  .medsTable td {
    white-space: nowrap;
  }
  .commonTable td > .el-button {
    display: inline-block;
    margin-right: 0.5em !important;
    vertical-align: middle;
  }
  .commonTable td > .el-button:last-child {
    margin-right: 0;
  }
  @media (max-width: 768px) {
    .blood-actions {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
    }
    .blood-actions .el-button {
      margin: 0 0 0.5em 0 !important;
      width: auto !important;
    }
    .kokai-flg .el-radio {
      margin: 1em 0 1em 0 !important;
      display: block !important;
      // white-space: normal !important;
    }
    .commonSubTable img {
      height: 125px !important;
    }
  }
  .pet-image-row {
    display: flex;
    gap: 24px;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    margin-bottom: 24px;
  }
  .pet-card {
    flex: 1 1 320px;
    max-width: 400px;
    min-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .pet-image {
    width: 100%;
    height: 200px;
    object-fit: contain;
  }
  /* 768px未満の場合は1列表示 */
  @media (max-width: 767px) {
    .pet-image-row {
      flex-direction: column;
      gap: 12px;
    }
    .pet-card {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
  .img-upload-comment span {
    white-space: nowrap;
  }
  @media (max-width: 767px) {
    .img-upload-comment span {
      white-space: normal;
      word-break: break-word;
    }
  }
</style>